import { render, staticRenderFns } from "./PageNoConfigUser.vue?vue&type=template&id=518b08f1&scoped=true&"
import script from "./PageNoConfigUser.vue?vue&type=script&lang=js&"
export * from "./PageNoConfigUser.vue?vue&type=script&lang=js&"
import style0 from "./PageNoConfigUser.vue?vue&type=style&index=0&id=518b08f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518b08f1",
  null
  
)

export default component.exports